import { defineStore } from "pinia";
export const useUserStore = defineStore("UserStore", {
    state: () => {
        return {
            user: {},
        };
    },
    actions: {
        logout() {
            this.user = {};
        },
        hasToken() {
            return this.user.token != undefined;
        },
        hasAuthority(authority) {
            if (this.user.grantedAuthorities == null) {
                return false;
            }
            return this.user.grantedAuthorities.find(value => value === authority) != null;
        }
    },
    persist: true
});
